





















import {
  defineComponent,
  PropType,
  reactive,
  toRef,
  useRoute,
  watch,
} from '@nuxtjs/composition-api';

import { ProductInterface } from '~/modules/GraphQL/types';

import Carousel from './Carousel/Carousel.vue';
import Thumbnails from './Thumbnails/Thumbnails.vue';

export default defineComponent({
  name: 'MainCarousel',
  components: {
    Carousel,
    Thumbnails,
  },
  props: {
    product: {
      type: [Object, null] as PropType<ProductInterface | null>,
      default: null,
    },
    images: {
      type: Array,
      required: true,
    },
    sliderOptions: {
      type: Object,
      default: () => ({
        type: 'slider',
        autoplay: false,
        rewind: false,
        perView: 1,
        dragThreshold: 0,
      }),
    },
  },
  emits: ['toggle'],
  setup(props, { emit }) {
    const images = toRef(props, 'images');
    const route = useRoute();

    const data = reactive({
      activeIndex: 0,
      pictureSelected: images.value?.[0] || {
        alt: '',
        zoom: '',
        big: {
          url: '',
        },
        desktop: '',
        placeholder: '',
      },
      currentPage: 0,
      hideImageAtIndex: null,
      imageMinHeight: 296,
    });

    const openOverlay = () => {
      emit('toggle', { currentSlide: data.activeIndex, currentPage: 0 });
    };
    const go = (index: number) => {
      data.hideImageAtIndex = images[index];
      data.activeIndex = index;
    };

    const setInitialPage = () => go(0);

    watch(route, () => {
      setInitialPage();
    });

    return {
      data,
      openOverlay,
      go,
    };
  },
});
